/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Cta_BookInputs */

const en_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book A Lesson`)
};

const es_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservar una lección`)
};

const de_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfstunde buchen`)
};

const zh_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预约课程`)
};

const ar_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احجز درساً`)
};

const fr_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservez une leçon`)
};

const vi_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt buổi học`)
};

const sw_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weka nafasi ya somo`)
};

const th_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จองบทเรียน`)
};

const bs_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervišite lekciju`)
};

const ja_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスンを予約する`)
};

const ko_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레슨 예약`)
};

const pt_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agende uma aula`)
};

const it_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenota una lezione`)
};

const sv_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boka en lektion`)
};

const nl_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boek een les`)
};

const da_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book en lektion`)
};

const nb_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestill en time`)
};

const fi_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varaa oppitunti`)
};

const pl_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj lekcję`)
};

const ru_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записаться на урок`)
};

const tr_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ders rezervasyonu yap`)
};

const hi_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ बुक करें`)
};

const id_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan pelajaran`)
};

const ms_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempah pelajaran`)
};

const cs_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezervujte si lekci`)
};

const el_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κλείστε μάθημα`)
};

const he_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזמינו שיעור`)
};

const af_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boek 'n les`)
};

const hu_contact_cta_book = /** @type {(inputs: Contact_Cta_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Óra foglalása`)
};

/**
* | output |
* | --- |
* | "Book A Lesson" |
*
* @param {Contact_Cta_BookInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_cta_book = /** @type {((inputs?: Contact_Cta_BookInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Cta_BookInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_cta_book(inputs)
	if (locale === "de") return de_contact_cta_book(inputs)
	if (locale === "zh") return zh_contact_cta_book(inputs)
	if (locale === "ar") return ar_contact_cta_book(inputs)
	if (locale === "fr") return fr_contact_cta_book(inputs)
	if (locale === "vi") return vi_contact_cta_book(inputs)
	if (locale === "sw") return sw_contact_cta_book(inputs)
	if (locale === "th") return th_contact_cta_book(inputs)
	if (locale === "bs") return bs_contact_cta_book(inputs)
	if (locale === "ja") return ja_contact_cta_book(inputs)
	if (locale === "ko") return ko_contact_cta_book(inputs)
	if (locale === "pt") return pt_contact_cta_book(inputs)
	if (locale === "it") return it_contact_cta_book(inputs)
	if (locale === "sv") return sv_contact_cta_book(inputs)
	if (locale === "nl") return nl_contact_cta_book(inputs)
	if (locale === "da") return da_contact_cta_book(inputs)
	if (locale === "nb") return nb_contact_cta_book(inputs)
	if (locale === "fi") return fi_contact_cta_book(inputs)
	if (locale === "pl") return pl_contact_cta_book(inputs)
	if (locale === "ru") return ru_contact_cta_book(inputs)
	if (locale === "tr") return tr_contact_cta_book(inputs)
	if (locale === "hi") return hi_contact_cta_book(inputs)
	if (locale === "id") return id_contact_cta_book(inputs)
	if (locale === "ms") return ms_contact_cta_book(inputs)
	if (locale === "cs") return cs_contact_cta_book(inputs)
	if (locale === "el") return el_contact_cta_book(inputs)
	if (locale === "he") return he_contact_cta_book(inputs)
	if (locale === "af") return af_contact_cta_book(inputs)
	if (locale === "hu") return hu_contact_cta_book(inputs)
	return en_contact_cta_book(inputs)
});